import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2, Truck, Delete } from 'lucide-react'
import toast from 'react-hot-toast'
import { motApi } from '@/lib/motoristaApi'

// Login do entregador: CPF + PIN (teclado numérico, estilo app de entrega).
export default function EntregadorLogin() {
  const nav = useNavigate()
  const [cpf, setCpf] = useState('')
  const [pin, setPin] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (localStorage.getItem('mot_token')) nav('/m/entregador/cargas', { replace: true })
  }, [])

  function maskCpf(v: string) {
    const d = v.replace(/\D/g, '').slice(0, 11)
    return d.replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2')
  }

  function tecla(n: string) {
    if (n === 'del') setPin((p) => p.slice(0, -1))
    else if (pin.length < 8) setPin((p) => p + n)
  }

  async function entrar() {
    if (cpf.replace(/\D/g, '').length !== 11 || pin.length < 4) {
      toast.error('Informe CPF completo e PIN (4+ dígitos).')
      return
    }
    setLoading(true)
    try {
      const { data } = await motApi.post('/login', { cpf, pin })
      localStorage.setItem('mot_token', data.access_token)
      localStorage.setItem('mot_info', JSON.stringify(data.motorista))
      nav('/m/entregador/cargas', { replace: true })
    } catch (e: any) {
      setPin('')
      toast.error(e?.response?.data?.detail || 'CPF ou PIN inválido')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-emerald-700 via-emerald-800 to-teal-900 text-white px-6 py-8">
      <div className="flex-1 flex flex-col items-center justify-center max-w-sm mx-auto w-full">
        <div className="w-20 h-20 rounded-2xl bg-white/15 backdrop-blur flex items-center justify-center mb-3 shadow-xl">
          <Truck className="h-10 w-10" />
        </div>
        <h1 className="text-2xl font-extrabold tracking-tight">Entregas Velore</h1>
        <p className="text-white/70 text-sm mt-1 mb-6">Acesso do motorista</p>

        <div className="w-full">
          <label className="text-xs uppercase opacity-80 font-bold ml-1">CPF</label>
          <input
            type="tel" inputMode="numeric" value={cpf}
            onChange={(e) => setCpf(maskCpf(e.target.value))}
            placeholder="000.000.000-00"
            className="w-full h-14 mt-1 px-4 bg-white/15 backdrop-blur border-2 border-white/20 focus:border-emerald-300 focus:outline-none rounded-2xl text-white placeholder-white/40 text-lg tracking-wider text-center"
            autoFocus
          />
        </div>

        <div className="w-full mt-4">
          <label className="text-xs uppercase opacity-80 font-bold ml-1">PIN</label>
          <div className="h-14 mt-1 flex items-center justify-center gap-3 bg-white/10 rounded-2xl border-2 border-white/20">
            {Array.from({ length: Math.max(4, pin.length) }).map((_, i) => (
              <div key={i} className={`w-4 h-4 rounded-full ${i < pin.length ? 'bg-emerald-300' : 'bg-white/25'}`} />
            ))}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3 w-full mt-5">
          {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((n) => (
            <button key={n} onClick={() => tecla(n)}
              className="h-16 rounded-2xl bg-white/10 hover:bg-white/20 active:bg-white/30 text-2xl font-bold transition">{n}</button>
          ))}
          <div />
          <button onClick={() => tecla('0')}
            className="h-16 rounded-2xl bg-white/10 hover:bg-white/20 active:bg-white/30 text-2xl font-bold transition">0</button>
          <button onClick={() => tecla('del')}
            className="h-16 rounded-2xl bg-white/10 hover:bg-white/20 active:bg-white/30 flex items-center justify-center transition"><Delete className="h-6 w-6" /></button>
        </div>

        <button onClick={entrar} disabled={loading}
          className="w-full h-16 mt-6 bg-emerald-400 hover:bg-emerald-500 active:bg-emerald-600 text-emerald-950 font-extrabold text-lg rounded-2xl flex items-center justify-center gap-2 shadow-xl disabled:opacity-40 transition">
          {loading ? <Loader2 className="h-6 w-6 animate-spin" /> : 'Entrar'}
        </button>
      </div>
      <div className="text-center text-xs text-white/40 pt-4">VELORE ERP · App do Entregador</div>
    </div>
  )
}
